<template>
    <div class="main">
        <div class="topbanner"><img src="../../../assets/img/newslist.jpg"></div>
        <div class="maincon">
            <h1>{{ newDe.TNM_TITLE }}</h1>
            <div class="flexbox newsdate">
                <p>发布时间：{{ newDe.TNM_UPTIME }}</p>
                <!-- <p>浏览：{{ newDe.TNM_UPTIME }}</p> -->
            </div>
            <div class="con" v-html="newDe.TNM_CONTENT">
               
            </div>
            <div class="anothernews">
                <div>
                    <router-link class="flexbox" :to="'/newslist/' + newPrev.TNM_ID + '&' + newPrev.TNM_ORDER" v-if="newPrev.TNM_TITLE" @click.native="refreshpage">
                        <p>上一篇</p>
                        <h2>{{ newPrev.TNM_TITLE }}</h2>
                        <div class="date">{{ newPrev.TNM_UPTIME }}</div>
                    </router-link>
                    <div class="flexbox" v-else>
                        <p>上一篇</p>
                        <h2>暂无数据</h2>
                    </div>
                </div>
                <div>
                    <router-link class="flexbox" :to="'/newslist/' + newNext.TNM_ID + '&' + newNext.TNM_ORDER" v-if="newNext.TNM_TITLE" @click.native="refreshpage">
                        <p>下一篇</p>
                        <h2>{{ newNext.TNM_TITLE }}</h2>
                        <div class="date">{{ newNext.TNM_UPTIME }}</div>
                    </router-link>
                    <div class="flexbox" v-else>
                        <p>下一篇</p>
                        <h2>暂无数据</h2>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import { ref, onMounted, getCurrentInstance, onBeforeMount } from 'vue'
    import { useRouter } from 'vue-router'

    export default {
        name: 'NewsDetail',
        components: {
            
        },
        setup() {
            let { proxy } = getCurrentInstance()
            let router = useRouter()
            let newsMsg = ref([])
            let order = ref('')
            let newsId = ref('')
            let newDe = ref('')
            let newNext = ref('')
            let newPrev = ref('')
            let getNewsDetail = () => {
                let url = '/meide/REST/ajaxTouTiao'
                let data = {
                    postType: 'queryone',		
                    ORDER: newsMsg.value[1],// 头条排序	
                    ID: newsMsg.value[0], // 头条ID
                }
               proxy.$axios.postReq(url, data)
                .then(res => {
                    if(res.success == 'true') {
                        for(let i=0; i< res.items.length; i ++) {
                            if(res.items[i].POSITION == 'DQY') {
                                newDe.value = res.items[i]
                            }else if (res.items[i].POSITION == 'XYY') {
                                newNext.value = res.items[i]
                            }else if (res.items[i].POSITION == 'SYY') {
                                newPrev.value = res.items[i]
                            }
                        }
                    }else {
                        proxy.$alert(res.ErrorText, '提示', {
                            confirmButtonText: '确定',
                            callback: action => {}
                        });
                    }
                }).catch(error => {
                    // proxy.$alert(error, '提示', {
                    //     confirmButtonText: '确定',
                    //     callback: action => {}
                    // });
                })
            }
            // 当前页跳转
            let refreshpage = () => {
                setTimeout(() => {
                    router.go(0)
                }, 200)
            }
            onBeforeMount(() => {
                let msg = router.currentRoute.value.params.id
                newsMsg.value = msg.split('&')
                getNewsDetail()
            })
            onMounted(() => {
                document.title = '新闻详情'
            })
            return {
                newsMsg,
                order,
                newsId,
                newDe,
                newNext,
                newPrev,
                getNewsDetail,
                refreshpage
            }
        }
    }
</script>

<style scoped lang="scss">
    .main {
        background: #fafafa;
        padding-bottom: 50px;
    }
    .topbanner {
        width: 1200px;
        margin: auto;
        img {
            width: 100%;
        }
    } 
    .maincon {
        width: 1200px;
        margin: auto;
        padding: 40px;
        background: #fff;
        h1 {
            font-size: 16px;
            font-weight: bold;
            margin-bottom: 20px;
        }
        .newsdate {
            padding-bottom: 20px;
            border-bottom: 1px solid #ddd;
            padding-left: 5px;
            margin-bottom: 30px;
            p {
                color: #999;
                margin-right: 20px;
            }
        }
        .con {}
        .anothernews {
            margin-top: 40px;
            .flexbox {
                padding: 20px;
                border-top: 1px solid #eee;
                border-bottom: 1px solid #eee;
                cursor: pointer;
                color: #333;
                width: 100%;
                p {
                    width: 70px;
                }
                h2 {
                    font-weight: bold;
                    margin: 0 20px;
                    width: 85%;
                }
                .date {
                    font-size: 12px;
                    width: 150px;
                }
            }
        }
    }
</style>